import { Badge } from '@mantine/core';
import type { RegistrationSessionModelView } from '@actschurch/ccms-sdk';

interface SessionStateBadgeProps {
  session: RegistrationSessionModelView;
  kind: 'status' | 'progress';
}

/** Read-only counterpart of the admin `SessionStateMenu`: same look, no dropdown, no writes. */
export default function SessionStateBadge({ session, kind }: SessionStateBadgeProps) {
  const label = kind === 'status'
    ? session.effectiveStatusName ?? session.statusName ?? '—'
    : session.progressStatusName ?? '—';

  const color = kind === 'status'
    ? session.effectiveStatusColor ?? session.statusColor ?? undefined
    : session.progressStatusColor ?? undefined;

  return (
    <Badge
      variant="light"
      size="sm"
      style={{
        backgroundColor: color ? `${color}22` : undefined,
        color,
        border: color ? `1px solid ${color}55` : undefined,
      }}
    >
      {label}
    </Badge>
  );
}
